import { UiDataPartType } from "@juristic/types/stream/ai/data_events";
import { WorkflowEventType } from "@juristic/types/stream/ai/workflow";
const COMPACTION_EVENTS = new Set([
    WorkflowEventType.CompactionStarted,
    WorkflowEventType.CompactionCompleted,
    WorkflowEventType.CompactionFailed
]);
const READING_EVENTS = new Set([
    WorkflowEventType.AttachmentsReadingStarted,
    WorkflowEventType.AttachmentsReadingCompleted
]);
function eventOf(part, events) {
    if (part.type !== UiDataPartType.Workflow) return undefined;
    return events.has(part.data.type) ? part.data.type : undefined;
}
const compactionEvent = (part)=>eventOf(part, COMPACTION_EVENTS);
function isLatest(parts, events, started) {
    for(let i = parts.length - 1; i >= 0; i -= 1){
        const event = eventOf(parts[i], events);
        if (event) return event === started;
    }
    return false;
}
export const isCompacting = (parts)=>isLatest(parts, COMPACTION_EVENTS, WorkflowEventType.CompactionStarted);
export const isReadingAttachments = (parts)=>isLatest(parts, READING_EVENTS, WorkflowEventType.AttachmentsReadingStarted);
export function isCompactionDivider(parts, index) {
    const isCompleted = compactionEvent(parts[index]) === WorkflowEventType.CompactionCompleted;
    if (!isCompleted) return false;
    for(let i = index - 1; i >= 0; i -= 1){
        const part = parts[i];
        const event = compactionEvent(part);
        if (event === WorkflowEventType.CompactionCompleted) return false;
        if (event === WorkflowEventType.CompactionStarted) return true;
        if (part.type !== "step-start" && part.type !== UiDataPartType.Workflow) return true;
    }
    return true;
}
